<template>
  <div class="w-full h-full">
    <ContractEmployees />
  </div>
</template>

<script>
import ContractEmployees from "@/components/contractEmployees";

export default {
  name: "ContractEmployeesView",
  components: {
    ContractEmployees,
  },
};
</script>
